var _path, _path2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgTimer = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 33,
  height: 33,
  fill: "none"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "timer_svg__a",
  width: 33,
  height: 33,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#555",
  stroke: "#fff",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M16.5 31.447c8.285 0 15-6.715 15-15 0-8.284-6.715-15-15-15-8.284 0-15 6.716-15 15 0 8.285 6.716 15 15 15Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#fff",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "M16.506 7.447v9.008l6.36 6.36"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#timer_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#37BDD2",
  d: "M-1.5-1.553h36v36h-36v-36Z"
}))));
export default SvgTimer;